import React from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";
import isApp from "shared/util/isApp";

import { FIELDS } from "../util/constants";

const Button = (props) => {
	let buttonText;
	let buttonDisabled;

	if (props.currentField === FIELDS.EMAIL_OR_FB) {
		if (props.isSubmitting) {
			buttonText = _str("Submitting...");
		} else if (props.isSuccess) {
			buttonText = _str("Success!");
		} else {
			buttonText = _str("Next");
		}

		buttonDisabled = !props.fieldIsValid;
	} else if (props.currentField === FIELDS.REGISTRATION) {
		if (props.isSubmitting) {
			buttonText = _str("Creating account...");
		} else if (props.isSuccess) {
			buttonText = _str("Success!");
		} else {
			buttonText = _str("Sign up");
		}

		buttonDisabled = !props.fieldIsValid || props.isSuccess;
	} else {
		return null;
	}

	return (
		<div>
			{/* for the "go" button to submit the form on the apps, we need an
					input rather than a button. the app's styles hide this. */}
			{isApp() &&
				<input type="submit" />
			}

			<button
				className="signup2017-button"
				disabled={buttonDisabled}
				onClick={props.onSave}
			>
				{buttonText}
			</button>
		</div>
	);
};

Button.propTypes = {
	currentField: PropTypes.string.isRequired,
	fieldIsValid: PropTypes.bool,
	isSubmitting: PropTypes.bool,
	isSuccess: PropTypes.bool,
	onSave: PropTypes.func.isRequired,
};

export default Button;



// WEBPACK FOOTER //
// ./src/apps/signup/components/Button.jsx